// extracted by mini-css-extract-plugin
export default {"feed":"FeedPhoto_feed__qt8Kk","noPhoto":"FeedPhoto_noPhoto__WhfpQ"};